<template>
  <div class="">
    <div v-if="HasReservation">
      <div class="panal mt-20">
        <div class="panal-header">Your Booking</div>
        <div class="panal-body">
          <div class="row">

 <div class="col-md-3 col-sm-12">
                    <div class="profileData">Room Gatgory</div>
                  </div>
                  <div class="col-md-3 col-sm-12">
                    <div class="profileData2">
                       {{ RoomCategory }}
                    </div>
                  </div>

 <div class="col-md-3 col-sm-12">
                    <div class="profileData">Period </div>
                  </div>
                  <div class="col-md-3 col-sm-12">
                    <div class="profileData2">
                        {{ Period }}
                    </div>
                  </div>

           
            
            <div class="col-12 col-md-3 mb-1 mt-2">Room Descriptaion :</div>
            <div class="col-12">
              <b-alert show variant="info">{{ description }}</b-alert>
            </div>

            <div class="col-12 text-center">
              <b-button
                variant="success"
                size="sm"
                class="mt-2"
                @click="CancelReservation"
                >Cancel Booking</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="panal mt-20">
        <div class="panal-header">Your Booking</div>
        <div class="panal-body">
          <p>You dont have reservation</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DormsServices from "../../services/Dorms/Dorms.service";

export default {
  name: "Destinations",
  data() {
    return {
      RoomCategory: "",
      Period: "",
      description: "",
      PersonReservationId: "",
      HasReservation: false,
    };
  },
  computed: {
    currenUser() {
      return this.$store.state.auth.user;
    },
  },

  mounted() {
    DormsServices.ReservationInfo(this.currenUser.Username)
      .then((response) => {
        this.RoomCategory = response.data.DataList.Room_Category;
        this.Period = response.data.DataList.DurationName;
        this.description = response.data.DataList.Description;
        this.PersonReservationId = response.data.DataList.Serial;
        this.HasReservation = true;
        console.log(response.data);
      })
      .catch((err) => console.log(err));
  },
  methods: {
    CancelReservation() {
      DormsServices.CancelReservation(
        this.PersonReservationId,
        this.currenUser.UserIDSerial
      )
        .then((respone) => {
          console.log(respone.data);
          alert("Cancelled Successfuly");
          this.HasReservation = false;
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style scoped>
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}
table tr th {
  background-color: #4caf5000 !important;
  color: #333;
  font-weight: bold;
}

.panal {
  background: #fff;
  border-radius: 10px;
  border: 1px solid #d4d4d4;
  color: #fff;
  border: 1px solid #cecece;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}

.divider {
  *width: 100%;
  height: 1px;
  margin: 9px 1px;
  *margin: -5px 0 5px;
  overflow: hidden;
  /* background-color: #e5e5e5; */
  border-bottom: 1px dotted #e5e5e5;
}
.su-border {
  border-color: #3d8fe3 !important;
  background: #f1f9ff !important;
}
.panal-body {
  padding: 20px;
  color: #333;
}
.app-stu-photo {
  float: right;
  width: 200px;
  border-radius: 10px;
  border: 1px solid #111;
  margin-top: 20px;
}
.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}
.app-All {
  width: 80%;
  float: left;
}
.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;
}
.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-light th {
  font-size: 14px !important;
}
.table .thead-light th {
  font-size: 14px !important;
  background-color: #eaeaea !important;
}

.panal2 {
  background: #eee;
  border-radius: 10px;
  color: #333;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header2 {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body2 {
  padding: 20px;
  color: #333;
}
.mt-10 {
  margin-top: 10px;
}

.btn {
  margin-left: 5px;
}

@media only screen and (max-width: 600px) {
  .panal-header {
    width: 90% !important;
  }
  .app-stu-photo {
    float: none;
  }
}

.profileData,
.profileData2 {
  border: 1px dotted #646464;
  padding: 3px 10px;
  font-weight: 700;
  margin: 5px 0px;
}
.profileData {
  color: #285475;
}
.profileData2 {
  color: #ff8600;
}
</style>